export const FETCH_SELECTED_CHANNEL_PENDING = 'FETCH_SELECTED_CHANNEL_PENDING';
export const FETCH_SELECTED_CHANNEL_SUCCESS = 'FETCH_SELECTED_CHANNEL_SUCCESS';
export const FETCH_SELECTED_CHANNEL_ERROR = 'FETCH_SELECTED_CHANNEL_ERROR';
